import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { ListServiceTypeResponse } from '@fitness-force/models';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map, ignoreElements } from 'rxjs/operators';
import { environment } from '@fitness-force/environments';
import { AppErrors, NotFoundError } from '@fitness-force/models';;

@Injectable({
  providedIn: 'root'
})
export class ServiceTypeService {
  private http = inject(HttpClient);

  BASE_URL: string = environment.BASE_URL;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  GetServiceType(tenantId: number): Observable<ListServiceTypeResponse> {
    let url: string = this.BASE_URL + CONST_URL_SEGEMENTS.SERVICETYPE.GET_SERVICETYPE.replace('{tenant_id}', tenantId.toString());
    return this.http.get(url, this.httpOptions)
      .pipe(
        // should have been mapped 
        map((res: any) => { return res; }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
}
